import _ from 'lodash';
import type { FlowTask } from '@Types/FlowTask.interface';
import { useRequestFlowStore } from '@Stores/requestFlow.store';
import { useRoute } from 'vue-router';


export const useFlowSteps = () => {
    const requestFlowStore = useRequestFlowStore();

    const getProgressSteps = (): string[] => {
        const includedDisplayNames = new Set<string>();
        return _.map(
            _.filter(requestFlowStore.flowSteps, (task) => {
                if (!task.displayName) return false;
                if (includedDisplayNames.has(task.displayName)) return false;
                includedDisplayNames.add(task.displayName);
                return true;
            }),
            'displayName'
        ).filter(Boolean) as string[];
    };

    const getCurrentStep = (): string => {
        const currentRouteName = useRoute().name as string;
        const currentTask = _.find(requestFlowStore.flowSteps, { routeName: currentRouteName }) as FlowTask | undefined;
        return currentTask?.displayName ?? '';
    };

    return { getProgressSteps, getCurrentStep };
};

export default useFlowSteps;
